import { useSelector } from "react-redux";

export const GoogleReview = ({ type }) => {
  const state = useSelector((state) => state.reducer);

  return (
    <div className="bg-white shadow-sm border rounded-lg">
      <div className="p-6">
        <p className="font-bold text-xl">Google Reviews</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full font-medium text-[#6B707E]">
          <thead className="bg-[#F9FAFB]">
            <tr className="border-t border-b text-muted-foreground text-sm text-left">
              <th className="px-6 py-3 font-medium text-center">Number</th>
              <th className="px-6 py-3 font-medium text-center">
                Google Review Received Date
              </th>
              <th className="px-6 py-3 font-medium text-center">
                Google Review Star Number
              </th>
              <th className="px-6 py-3 font-medium text-center">
                Google Review Content
              </th>
            </tr>
          </thead>
          <tbody>
            {state.googleReviews?.map((item, index) => {
              return (
                <tr className="border-t">
                  <td className="px-6 py-4 text-center">{index + 1}</td>
                  <td className="px-6 py-4 text-center">
                    {item.date.split("T")[0]}
                  </td>
                  <td className="px-6 py-4 text-center">{item.stars}</td>
                  <td className="px-6 py-4 text-center">{item.content}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
